import { Component, OnInit, Input } from '@angular/core';
import { UnindexDateRangeCIF } from '../../../shared/viewmodels/RegUtility';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { UnindexSearchService } from '../../unindexed-search-service';
import { IndexGroupsVM } from '../../../shared/viewmodels/ISearchServiceReg';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';

@Component({
  selector: 'app-date-range-unindex',
  providers: [UnindexSearchService],
  templateUrl: './date-range-unindex.component.html',
  styleUrls: ['./date-range-unindex.component.css']
})
export class DateRangeUnindexComponent implements OnInit {

  public utilityobj: UnindexDateRangeCIF;
  datetabindex: number;
  roletype: number;
  message: any;
 // res: IndexGroupsVM[]=[];
  error: any;
  //selectedDate: string;
  public form: UntypedFormGroup;
  dategroup: number;
  @Input() majorgroup: string;
  constructor(private store: Store<AppState>, private service: UnindexSearchService, private fb: UntypedFormBuilder) {
    
    //this.store.select('regsearchdata').subscribe(data => this.message = data);
    //if (this.message.planrole.length != 0) {
    //  this.utilityobj.planroleID = this.message.planrole[0].planroleID;
    //  console.log(this.message.planrole[0]);
    //} else {
    //  this.utilityobj.planroleID = -1;
    //}
    //console.log(this.selectedDate);
  }

  ngOnInit() {
    this.utilityobj = new UnindexDateRangeCIF();
    console.log("majorgroup" + this.majorgroup);
    switch (this.majorgroup) {
      case "1640-1799":
        this.getDateRange(1, 1);
        break;
    case "1800-1854":
        this.getDateRange(2, 1);
        break;
    case "1855-1950":
        this.getDateRange(3, 1);
        break;
    case "1951-1963":
        this.getDateRange(4, 1);
        break;
    case "1964-1978":
        this.getDateRange(5, 1);
        break;
    }
   
  }

  getDateRange(majorgroup, roletype) {
    this.service.GetIndexMajorIndexGroup(majorgroup, roletype).subscribe(
      data => {
        this.utilityobj.dateranges = data
        this.dategroup = this.utilityobj.dateranges[0].dateGroup
        //this.utilityobj.dateranges.forEach(function (value) {
        //  value["isSelected"] = false;

        //}
        //);
        //this.form = this.fb.group({
        //  'dtrange': [this.utilityobj.dateranges[0].dateRange]
        //});
      },
      error => {this.error= error}
    );
  }

  selectdate(dt:any) {
    console.log("date" + dt);
    this.dategroup = dt;
    
  }
}
